import { useLazyLoadQuery } from "react-relay"
import type { chDuplicatePatientByIdQuery as ChQueryType } from "@/modules/patients/manage-duplicates/services/ch/__generated__/chDuplicatePatientByIdQuery.graphql"
import { chDuplicatePatientByIdQuery } from "@/modules/patients/manage-duplicates/services/ch/chDuplicatePatientByIdQuery"
import type { deDuplicatePatientByIdQuery as DeQueryType } from "@/modules/patients/manage-duplicates/services/de/__generated__/deDuplicatePatientByIdQuery.graphql"
import { deDuplicatePatientByIdQuery } from "@/modules/patients/manage-duplicates/services/de/deDuplicatePatientByIdQuery"
import { Country } from "@/types/__generated__/union-types"

const useDuplicatePatientByIdQuery = (country: Country, patientId: string) => {
  const query = country === "CH" ? chDuplicatePatientByIdQuery : deDuplicatePatientByIdQuery

  const data = useLazyLoadQuery<ChQueryType | DeQueryType>(query, { patientId })

  const patient = "ch_patientById" in data ? data.ch_patientById : data.de_patientById

  return {
    patient,
    duplicatePatients: patient?.duplicatePatients ?? [],
  }
}

export { useDuplicatePatientByIdQuery }
